import { useEffect, useState } from 'react';
import { resolveVariant, trackExposure } from '../../utils/experimentAssignment';
import Landing from '../Landing/Landing';

// A/A test: both arms render the same Landing page through this entry. Three
// /benefithub variants lost in a row, so this checks the experiment setup
// itself (split, exposure tracking, analysis) rather than a design change.
const FLAG_KEY = 'benefithub-aa-test';

// Share of /benefithub visitors entering the experiment at all. Keep this in sync
// with the flag's rollout in PostHog, since a visitor with cached flags is
// assigned by the flag instead.
const ENROLLED_SHARE = 1.0;

// Share of *enrolled* visitors assigned to the "test" arm (same page as control).
const TEST_SHARE = 0.50;

export default function BenefitHubExperimentEntry() {
    // Resolved once, synchronously, exactly as in a real test, so both arms go
    // through the same assignment and exposure path.
    const [assignment] = useState(() =>
        resolveVariant({ flagKey: FLAG_KEY, enrolledShare: ENROLLED_SHARE, testShare: TEST_SHARE })
    );

    useEffect(() => {
        trackExposure(FLAG_KEY, assignment.variant);
    }, [assignment.variant]);

    return <Landing />;
}
